import { GenericDialog } from "./GenericDialog";

export type ConfirmationDialogProps = {
  caption: string;
  message: string;
  onAccept?: () => void;
  onCancel?: () => void;
};

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  return (
    <GenericDialog buttons="OKCancel" {...props}>
      {props.message}
    </GenericDialog>
  );
}
